import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

interface IsSmallProps {
    $isSmall?: boolean;
}
export const Wrapper = styled(motion.div)<IsSmallProps>`
    display: grid;
    height: 81px;
    width: 81px;
    gap: 2px;
    grid-template-columns: 50% 50%;
    grid-template-rows: 50% 50%;
    flex-shrink: 0;

    ${({ $isSmall }) =>
        $isSmall &&
        css`
            height: 40px;
            width: 40px;
            gap: 1px;
        `};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        ${({ $isSmall }) =>
            $isSmall &&
            css`
                height: 60px;
                width: 60px;
                gap: 1px;
            `};
    }
`;

const sharedImg = css`
    && {
        display: inline-grid;
        background: rgba(255, 255, 255, 0.1);
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            border-radius: 0;
            background: black;
        }
        video {
            width: 100%;
            height: 100%;
            border-radius: 0;
            background: black;
        }
    }
`;

export const Left = styled.div<IsSmallProps>`
    && {
        ${sharedImg};
        border-radius: 8px 0 0 8px;
        height: calc(100% + 2px);
        grid-column-start: 1;
        grid-column-end: span 1;
        grid-row-start: 1;
        grid-row-end: span 2;

        ${({ $isSmall }) =>
            $isSmall &&
            css`
                height: calc(100% + 1px);
            `};
    }
`;

export const TopRight = styled.div`
    ${sharedImg};
    border-radius: 0 8px 0 0;

    grid-column-start: 2;
    grid-column-end: span 2;
    grid-row-start: 1;
    grid-row-end: span 1;
`;

export const BottomRight = styled.div`
    ${sharedImg};
    border-radius: 0 0 8px 0;

    grid-column-start: 2;
    grid-column-end: span 2;
    grid-row-start: 2;
    grid-row-end: span 2;
`;
